import React from 'react';
import BaseClass from '@/pages/BaseClass';
import OrderDetail from '@/components/OrderDetail';

import $ from 'jquery';
import moment from 'moment';
import XLSX from 'xlsx';
import axios from 'axios';
//import XLSXS from 'xlsx-style';
import {
	Form,
	Table,
	Button,
	Input,
	Select,
	Modal,
	DatePicker,
	Menu,
	Dropdown,
	Row,
	Col,
	Divider,
	Image,
	Radio,
	Tabs,
	Checkbox,
	Pagination,
	Empty,
	Popconfirm,
} from 'antd'
import {
	CommonValue,
	ngUrl,
	pcUrl,
	confirm,
	message,
	notify,
	httpPost,
	download,
	parseTime,
	formatTime,
	accAdd,
	getQuery,
} from '@/utils/Tools';

const {Column,ColumnGroup} = Table;
const {Option} = Select;
export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			'userInfo':{},
			'statusList':{},
			
			'orderTypeList':{},
			'orderType':-1,
			'orderStatus':-1,
			'selectedRowKeys':[],
			'list':[],
			'showDialog':false,
			'showPayDialog':false,
			
			'totalAmount':0,
			'pageInfo':{
				'current':1,
				'total':0,
				'pageSize':5,
			},
			
			'orderInfo':{},
			'selectAll':false,
			'info':{
				'extra_info':{
					'order_category':[],
				},
				'image_list':[],
			},
		};
	}
	
	componentDidMount()
	{
		let userInfo = CommonValue.get('user_info');
		this.setState({
			'userInfo':userInfo,
		});

		let query = getQuery();
		if(query['order_status'] != undefined)
		{
			this.setState({
				'orderStatus':query['order_status']
			});
			this.filterForm && this.filterForm.setFieldsValue({
				'order_status':query['order_status']
			});
		}
		if(query['order_type'] != undefined)
		{
			this.filterForm && this.filterForm.setFieldsValue({
				'order_type':+query['order_type']
			});
		}
		
		//this.getStatusList()
		this.getList();
		this.getOrderTypeList();
		
		document.title = '我的订单 - ' + CommonValue.get('site_name');
	}
	componentWillUnmount()
	{
		if(this.loop)
			window.clearInterval(this.loop);
	}
	
	getStatusList(orderType)
	{
		let url = pcUrl('order','statusList');
		let param = {
			'order_type':orderType,
		};
		
		httpPost(url,param)
			.then(data=>{
				this.setState({
					'statusList':data,
				});
			});
	}
	getOrderTypeList()
	{
		let url = pcUrl('order','typeList');
		httpPost(url)
			.then(data=>{
				this.setState({
					'orderTypeList':data,
				});
			});
	}
	
	getList(page,pageSize)
	{
		if(!page) page = 1;
		if(!pageSize) pageSize = this.state.pageInfo.pageSize;
		
		let url = pcUrl('order','index');
		let param = this._parseFilter(this.filterForm.getFieldsValue());
		param['page'] = page;
		param['page_size'] = pageSize;
		
		httpPost(url,param)
			.then(data=>{
				data['list'].forEach(row=>{
					row.key = row['order_id'];
					row.selected = false;
				});
				
				this.setState({
					'list':data['list'],
					'pageInfo':{
						'current':page,
						'total':data['page_info'].total,
						'pageSize':pageSize,
					},
					'totalAmount':data['total_amount'],
				});
				
			});
	}
	_parseFilter(filter)
	{
		if(filter.time && filter.time.length)
		{
			filter['start_time'] = moment(filter.time[0]).format('YYYY-MM-DD');
			filter['end_time'] = moment(filter.time[1]).format('YYYY-MM-DD');
			delete(filter.time);
		}
		return filter;
	}
	
	//全选操作
	toggleSelectAll(selected)
	{
		let list = this.state.list;
		list.forEach(row=>{
			row.selected = selected;
		});
		
		this.setState({
			'list':list,
			'selectAll':selected,
		},()=>{
			this.calcTotalAmount();
		});
	}
	
	toggleSelect(selected,index)
	{
		let list = this.state.list;
		list[index]['selected'] = selected;
		let data = {
			'list':list,
		};
		
		if(!selected && this.state.selectAll)
		{
			data['selectAll'] = false;
		}
		else if(selected && !list.some(row=>!row.selected) && !this.state.selectAll)
		{
			data['selectAll'] = true;
		}
		
		this.setState(data,()=>{
			this.calcTotalAmount();
		});
	}
	
	clearSelection()
	{
		let list = this.state.list;
		list.forEach(row=>{
			row.selected = false;
		});
		
		this.setState({
			'list':list,
			'selectAll':false,
		});
	}
	
	calcTotalAmount()
	{
		//let totalAmount = this.state.list.filter(row=>row.selected).map(row=>+row['order_amount']).reduce((val,newVal)=>Math.round(accAdd(val,newVal)*100)/100);
		let values = this.state.list.filter(row=>row.selected).map(row=>+row['order_amount']);
		let url = pcUrl('order','calcTotalAmount');
		let param = {
			'values':values.join(',')
		};
		httpPost(url,param)
			.then(data=>{
				this.setState({
					'totalAmount':data,
				});
			});
		
	}
	
	export()
	{
		//let selection = this.state.selectedRowKeys;
		let selection = this.state.list.filter(row=>row.selected);
		
		if(!selection.length)
		{
			if(!+this.state.pageInfo.total)
			{
				message('无可导出数据');
				return false;
			}
			
			confirm('您没有选择要导出的数据，确认导出所有订单吗?')
				.then(()=>{
					let url = pcUrl('order','export');
					let param = this._parseFilter(this.filterForm.getFieldsValue());
					/*
					httpPost(url,param)
						.then(data=>{
							this._export(data);
						});
					*/
					download(url,param)
						.then(()=>{
							this.clearSelection();
						});
				});
		}
		else
		{
			let url = pcUrl('order','export');
			let filter = this.filterForm.getFieldsValue();
			let param = {
				//'order_ids':this.state.selectedRowKeys.join(','),
				'order_ids':selection.map(row=>row['order_id']).join(','),
				'order_type':filter['order_type'],
			};
			/*
			httpPost(url,param)
				.then(data=>{
					this.clearSelection();
					this._export(data);
				});
			*/
			download(url,param)
				.then(()=>{
					this.clearSelection();
				});
		}
	}
	
	_export(rawData)
	{
		let tableHead = [
			{
				'key':'order_sn',
				'name':'订单编号',
				'group':'order_info',
			},
			{
				'key':'order_amount',
				'name':'订单金额',
				'group':'order_info',
			},
			{
				'key':'order_status',
				'name':'订单状态',
				'group':'order_info',
			},
			{
				'key':'add_time',
				'name':'下单时间',
				'group':'order_info',
			},
			
			
			{
				'key':'reciver_consignee',
				'name':'收货姓名',
				'group':'extra_info',
			},
			{
				'key':'reciver_phone',
				'name':'联系手机',
				'group':'extra_info',
			},
			{
				'key':'reciver_area_info',
				'name':'城市信息',
				'group':'extra_info',
			},
			{
				'key':'reciver_address',
				'name':'收货地址',
				'group':'extra_info',
			},
			{
				'key':'categories',
				'name':'材料',
			},
			{
				'key':'image_dimension',
				'name':'尺寸',
			},
			{
				'key':'image_price',
				'name':'单价',
			},
			{
				'key':'quantity',
				'name':'数量',
			},
			{
				'key':'image_amount',
				'name':'原价',
			},
			{
				'key':'pay_amount',
				'name':'现价',
			},
			{
				'key':'remark',
				'name':'备注',
			},
			{
				'key':'image_status',
				'name':'状态',
			},
		];
		
		// 新建空workbook，然后加入worksheet
		//const ws = XLSX.utils.json_to_sheet(data)
		/*
		data = [
			{
				'姓名':'张三',
				'年龄':20,
				'性别':'男',
			},
			{
				'姓名':'李四',
				'年龄':25,
				'性别':'女',
			},
		];
		data = [
			[
				'姓名',
				'年龄',
				'性别',
			],
			[
				'张三',
				20,
				//'男',
				//'<span class="green">123123</span>'
				'分类名1\n分类名2\n分类名3'
			],
			[
				'李四',
				25,
				'女',
			],
		];
		let wb = {
			SheetNames: ["mySheet"],
			Sheets: {
				mySheet: {
					"!ref":"A1:C1",
					A1: { t:"d", v:"30-Jan-1967" },
					B1: { t:"s", v:"This is some text" },
					C1: { t:"n", v:10000 }
				}
			}
		}
		let ws = {
			"!ref":"A1:C1",
			A1: { t:"d", v:"30-Jan-1967" },
			B1: { t:"s", v:"This is some text", s:{font:{sz:20,color:'red'}} },
			C1: { t:"n", v:10000 }
		};
		*/
		
		//组装数据
		let data = [];
		data.push(tableHead.map(row=>row.name));
		
		rawData.forEach((row,index)=>{
			let newRow = [];
			
			tableHead.forEach(row1=>{
				let key = row1.key;
				let name = row1.name;
				let group = row1.group;
				let value = '';
				if(group)
				{
					value = row[group][key];
				}
				else
					value = row[key];
				
				//数据处理
				//订单状态
				if('order_status' == key)
				{
					value = row[group]['order_status_exp'];
				}
				//下单时间
				else if('add_time' == key)
				{
					value = parseTime(value);
				}
				//材料
				else if('categories' == key)
				{
					value = row[key] ? row[key][1].join(',') : '';
				}
				//尺寸
				else if('image_dimension' == key)
				{
					value = value.length ? value.split('*').map(row=>row+'CM').join('*') : '';
				}
				//单价
				else if(
					'order_amount' == key ||
					'image_price' == key ||
					'image_amount' == key ||
					'pay_amount' == key
				)
				{
					value = '￥'+value;
				}
				//状态
				else if('image_status' == key)
				{
					value = row['image_status_exp'];
				}
				
				newRow.push(value);
			});
			data.push(newRow);
		});
		
		const ws = XLSX.utils.aoa_to_sheet(data)
		// 设置每列的列宽，10代表10个字符，注意中文占2个字符
		/*
		ws['!cols'] = [
			{ wch: 10 },
			{ wch: 30 },
			{ wch: 25 }
		]
		*/
		/*
		ws['!images'] = [];
		ws['!images'].push({
			name:'image1.jpeg',
			data: picBlob,
			opts: {base64 : true},
			position:{
				type: 'twoCellAnchor',
				attrs: {editAs:'oneCell'},
				from: { col: 2, row : 2 },
				to: { col: 6, row: 5 }
			}
		});
		*/
		// 新建book
		const wb = XLSX.utils.book_new()
		// 生成xlsx文件(book,sheet数据,sheet命名)
		XLSX.utils.book_append_sheet(wb, ws, '数据详情')
		// 写文件(book,xlsx文件名称)
		let fileName = '喷印订单导出列表'+formatTime('Y_m_d_H_i_s')+'.xlsx';
		XLSX.writeFile(wb, fileName);
		return;
	}
	
	/*
	export()
	{
		let selection = this.state.selectedRowKeys;
		let url = pcUrl('order','export');
		let param = this._parseFilter(this.filterForm.getFieldsValue());
		let _next = ()=>{
			download(url,param)
				.then(()=>{
					
				});
		};
		if(!selection.length)
		{
			confirm('您没有选择要导出的数据，确认导出所有订单吗?')
				.then(()=>{
					_next();
				});
		}
		else
		{
			param['order_ids'] = selection.join(',');
			_next();
		}
	}
	*/
	
	add()
	{
		this.setState({
			'showDialog':true,
		});
	}
	
	show(index)
	{
		this.setState({
			'showDialog':true,
		},()=>{
			this.orderDetail.init(this.state.list[index]['order_id']);
		});
	}
	
	//申请售后
	addService(index)
	{
		let info = this.state.list[index];
		if(!info['can_service'])
		{
			message('生产完成7天后的订单无法申请售后');
			return false;
		}
		this.props.history.push('/user/orderServiceAdd?orderSn='+info['order_sn']);
	}
	
	//申请退款
	addRefund(index)
	{
		confirm('确认要申请退款该订单?')
			.then(()=>{
				let info = this.state.list[index];
				
				let url = pcUrl('order','addRefund');
				let param = {
					'order_id':info['order_id']
				};
				httpPost(url,param)
					.then(()=>{
						//message('退款申请已提交，请等待管理员确认','success');
						message('申请已经提交，退款将于2分钟内依支付途径返还，请您确认');
						this.getList(this.state.pageInfo.current);
					});
			});
	}
	
	showPay(index)
	{
		let orderInfo = this.state.list[index];
		if(!+orderInfo['is_points'])
		{
			this.setState({
				'orderInfo':orderInfo,
				'showPayDialog':true,
			},()=>{
				/*
				this.payForm && this.payForm.setFieldsValue({
					'method':'alipay'
				});
				*/
				this.changeMethod('allinpay');
			});
		}
		//积分订单，直接支付
		else
		{
			confirm('该订单为积分订单，确认要支付该订单吗?')
				.then(()=>{
					let url = pcUrl('order','payPointsOrder');
					let param = {
						'order_id':orderInfo['order_id']
					};
					httpPost(url,param)
						.then(()=>{
							message('订单支付成功','success');
							this.getList(this.state.pageInfo.current);
						});
				});
		}
	}
	
	cancel(index)
	{
		confirm('确认要取消该订单吗?')
			.then(()=>{
				let url= pcUrl('order','cancel');
				let param = {
					'order_id':this.state.list[index]['order_id'],
				};
				httpPost(url,param)
					.then(()=>{
						message('订单取消成功','success');
						this.getList(this.state.pageInfo.current);
					});
			});
	}
	
	changeMethod(method)
	{
		if(this.loop)
			window.clearInterval(this.loop);
		
		if(method == 'wechatpay')
		{
			this.payForm.validateFields(['amount','method'])
				.then((info)=>{
					info.method = method;
					//微信充值，获取服务器返回的二维码
					this._submit(info)
						.then(data=>{
							this.setState({
								'wechatpay_qrcode':pcUrl('index','qrcode',{ 'code':escape(data.url), }),
							});
							let paySn = data['pay_sn'];
							paySn = paySn.split('_');
							paySn = paySn[0];
							//监听订单状态
							this.loop = window.setInterval(()=>{
								let url = pcUrl('user','payInfo');
								let param = {
									'pay_sn':paySn,
									'check_status':1,
								};
								httpPost(url,param)
									.then(data=>{
										//如果已支付状态
										if(10 == data.status)
										{
											this.props.history.push('/user/success?out_trade_no='+paySn);
										}
									});
							},2000);
						});
					
					this.payForm && this.payForm.setFieldsValue({'method':method});
				});
		}
		else if(method == 'allinpay')
		{
			this.payForm.validateFields(['method'])
				.then((info)=>{
					info.method = method;
					//微信充值，获取服务器返回的二维码
					this._submit(info)
						.then(data=>{
							this.setState({
								'wechatpay_qrcode':pcUrl('index','qrcode',{ 'code':escape(data.url), }),
							});
							let paySn = data['pay_sn'];
							paySn = paySn.split('_');
							paySn = paySn[0];
							//监听订单状态
							this.loop = window.setInterval(()=>{
								let url = pcUrl('user','payInfo');
								let param = {
									'pay_sn':paySn,
									'check_status':1,
								};
								httpPost(url,param)
									.then(data=>{
										//如果已支付状态
										if(10 == data.status)
										{
											//this.props.history.push('/user/success?out_trade_no='+paySn);
											window.location.href = '#/user/success?out_trade_no='+paySn;
										}
									});
							},2000);
						});
					
					this.payForm && this.payForm.setFieldsValue({'method':method});
				});
		}
		else
		{
			this.payForm && this.payForm.setFieldsValue({'method':method});
		}
	}
	
	submit(info)
	{
		this._submit(info)
			.then(data=>{
				//支付宝充值，直接进行跳转
				if(info.method == 'alipay')
				{
					document.write(data);
				}
				//余额支付，进入成功页
				else if(info.method == 'moneypay')
				{
					let paySn = data;
					this.props.history.push('/user/success?out_trade_no='+paySn);
				}
			});
	}
	
	_submit(info)
	{
		let url = pcUrl('order','charge');
		let param = {
			'order_id':this.state.orderInfo['order_id'],
			'method': ['alipay','wechatpay','moneypay','allinpay'].indexOf(info.method),
		};
		
		return new Promise((resolve,reject)=>{
			httpPost(url,param)
				.then(data=>{
					resolve(data);
				})
				.catch(e=>reject(e));
		});
	}
	
	render()
	{
		return (
			<div style={{'padding':'2em 1em'}}>
				{/*
					<Tabs type="card" defaultActiveKey="1">
						<Tabs.TabPane tab="项目1" key="1">
						</Tabs.TabPane>
						<Tabs.TabPane tab="项目2" key="2">
						</Tabs.TabPane>
						<Tabs.TabPane tab="项目3" key="3">
						</Tabs.TabPane>
					</Tabs>
				*/}
				<div>
					<Radio.Group
						options={[ {'label':'全部','value':-1} ].concat(Object.keys(this.state.orderTypeList).map(key=>{
							return {
								'label':this.state.orderTypeList[key],
								'value':key,
							};
						}))}
						value={this.state.orderType}
						optionType="button"
						buttonStyle="solid"
						size="middle"
						onChange={event=>{
							let status =  event.target.value;
							this.setState({
								'orderType':status,
							});
							
							if(-1 != status)
							{
								this.getStatusList(status);
								this.filterForm && this.filterForm.setFieldsValue({
									'order_type':status,
								});
							}
							else
							{
								this.filterForm && this.filterForm.resetFields(['order_type']);
							}
							this.getList();
						}}
					/>
				</div>
				{this.state.orderType != -1 && Object.keys(this.state.statusList).length && (
					<div style={{'margin-top':'.8em'}}>
						<Radio.Group
							options={[{'label':'全部','value':-1}].concat(Object.keys(this.state.statusList).map(key=>{
								return {
									'label':this.state.statusList[key],
									'value':key,
								};
							}))}
							value={this.state.orderStatus}
							optionType="button"
							buttonStyle="outline"
							size="middle"
							onChange={event=>{
								let status =  event.target.value;
								this.setState({
									'orderStatus':status,
								});
								
								if(-1 != status)
								{
									this.filterForm && this.filterForm.setFieldsValue({
										'order_status':status,
									});
								}
								else
								{
									this.filterForm && this.filterForm.resetFields(['order_status']);
								}
								this.getList();
							}}
						/>
					</div>
				)}
				<div className="height-20"></div>
				
				<div className="filter">
					<Form layout="inline" ref={e=>this.filterForm=e} onFinish={(data)=>this.getList()}>
						<Form.Item name="time">
							<DatePicker.RangePicker />
						</Form.Item>
						<Form.Item name="sort">
							<Select allowClear={true} style={{'width':'12em'}} placeholder="选择排序方式">
								<Option value="add_time_desc">下单时间由远至近</Option>
								<Option value="add_time_asc">下单时间由近至远</Option>
							</Select>
						</Form.Item>
						<Form.Item name="order_type" hidden></Form.Item>
						{/*
							<Form.Item name="order_type">
								<Select allowClear={true} style={{'width':'12em'}} placeholder="选择类别">
									<Option value={0}>喷印订单</Option>
									<Option value={1}>商品订单</Option>
								</Select>
							</Form.Item>
						*/}
						<Form.Item name="order_status" hidden></Form.Item>
						{/*
						<Form.Item name="order_status">
							<Select allowClear={true} style={{'width':'12em'}} placeholder="选择状态">
								{Object.keys(this.state.statusList).map(key=>(
								<Option value={key}>{this.state.statusList[key]}</Option>
								))}
							</Select>
						</Form.Item>
						*/}
						<Form.Item name="name">
							<Input allowClear={true} style={{'width':'12em'}} placeholder="订单号或订单名称" />
						</Form.Item>
						<Form.Item name="">
							<button className="button button-green">
								<span className="fa fa-search"></span>
								&nbsp;
								搜索
							</button>
						</Form.Item>
					</Form>
				</div>
				
				{this.state.list.length ? (
					<>
						<div style={{'margin':'1em 0px 1em'}}>
							<Checkbox checked={this.state.selectAll} onChange={(e)=>{this.toggleSelectAll(e.target.checked)}}> 全选 </Checkbox>
							&nbsp;
							{/*
							<Button type="primary" size="small" style={{'font-size':'12px'}} onClick={()=>message('功能正在开发中','success')}>批量付款</Button>
							&nbsp;&nbsp;
							*/}
							{this.filterForm && this.filterForm.getFieldValue('order_type') != undefined && (
								<>
									<Button size="small" style={{'font-size':'12px'}} onClick={()=>this.export()}>导出订单</Button>
									&nbsp;&nbsp;
									&nbsp;&nbsp;
								</>
							)}
							{this.state.list.some(row=>row.selected) && (
							<span>
								共计{this.state.list.filter(row=>row.selected).length}单，共{this.state.totalAmount}元
							</span>
							)}
						</div>
						<table className="order-table">
							<thead>
								<tr>
									<th width="40%"> 订单信息 </th>
									<th width="10%"> 文件数量 </th>
									<th width="10%"> 订单进度 </th>
									<th width="10%"> 订单金额 </th>
									<th width="10%"> 已付款 </th>
									<th width="10%"> 未付款 </th>
									<th width="10%"> 订单操作 </th>
								</tr>
							</thead>
							<tbody>
								{this.state.list.map((row,index)=>(
									<>
										<tr>
											<th colspan="7" style={{'font-size':'12px'}}>
												<a href="javascript:;" className="float-right" onClick={()=>this.show(index)}>
													<span className="fa fa-list-alt" style={{'margin-right':'.4em'}}></span>
													查看详情
												</a>
												<Checkbox checked={row.selected} onChange={e=>{let selected = e.target.checked; this.toggleSelect(selected,index); }}>
													<span style={{'font-size':'12px','color':'#666'}}> 订单号：{row['order_sn']} 下单时间：{formatTime('Y/m/d H:i:s',row['add_time'])}
													</span>
												</Checkbox>
											</th>
										</tr>
										<tr>
											<td>
												<div className="text-left" style={{'display':'flex','align-items':'center','padding':'1em'}}>
													<span style={{'min-width':'20%','font-size':'12px'}}> {this.state.orderTypeList[row['order_type']]} </span>
													<span style={{'min-width':'80%','font-size':'10px'}}>
														产品摘要：
														{row['order_name']}
													</span>
												</div>
											</td>
											<td>
												x{row['order_type'] == 0 ? row['image_count']:row['goods_count']}
											</td>
											<td>
												{row['order_status_exp']}
											</td>
											<td>
												{row['old_amount'] != row['order_amount'] && (
													<>
														<span className="text-gray line-through" style={{'font-size':'12px'}}> {!+row['is_points']?('￥'+row['old_amount']):(<>{row['old_amount']}<span style={{'fontSize':'12px'}}>积分</span></>)} </span>
														<br />
													</>
												)}
												<span className="text-orange"> {!+row['is_points']?('￥'+row['order_amount']):(<>{row['order_amount']}<span style={{'fontSize':'12px'}}>积分</span></>)} </span>
											</td>
											<td>
												{!+row['is_points']?(
													<span> ￥{+row['order_status']>=10 ? row['order_amount']:0} </span>
												):(
													<span> 
														{+row['order_status']>=10 ? row['order_amount']:0}
														<span style={{'fontSize':'12px'}}>积分</span>
													</span>
												)}
											</td>
											<td>
												{!+row['is_points']?(
												<span> ￥{+row['order_status']<10 ? row['order_amount']:0} </span>
												):(
												<span>
													{+row['order_status']<10 ? row['order_amount']:0}
													<span style={{'fontSize':'12px'}}>积分</span>
												</span>
												)}
											</td>
											<td>
												<div style={{'padding':'1em 0'}}>
													{/*
														<button className="button button-orange order-table-button">
															<span className="fa fa-shopping-basket"></span>
															修改货期
														</button>
													*/}
													
													{row['order_status'] == 0 && +this.state.userInfo['is_manager'] ? (
													<>
														<button className="button button-blue order-table-button small" onClick={()=>this.showPay(index)}>
															付款
														</button>
														&nbsp;&nbsp;
														<Popconfirm
															title="确认取消该订单吗?"
															onConfirm={()=>this.cancel(index)}
															onCancel={()=>{}}
															>
															<a href="javascript:;" className="order-table-link">取消</a>
														</Popconfirm>
													</>
													):''}
													{/*((row['order_type'] == 0 && [10,20,30].includes(+row['order_status']))||(row['order_type'] == 1 && [10,20].includes(+row['order_status'])))*/row['can_show_service'] && (
														<>
															<button className="button button-blue order-table-button small" onClick={()=>this.addService(index)}>
																<span className="fa fa-heart-o"></span>
																售后服务
															</button>
															<br/>
														</>
														
													)}
													{/*(row['is_points'] == 0 && [10,20,30].includes(+row['order_status']))*/row['can_refund'] &&  (
														<>
															<a href="javascript:;" className="order-table-link" onClick={()=>this.addRefund(index)}>申请退款</a>
														</>
													) }
												</div>
											</td>
										</tr>
									</>
								))}
							</tbody>
						</table>
						<div style={{'display':'flex','justify-content':'flex-end','margin':'16px 0'}}> <Pagination {...this.state.pageInfo} onChange={(page,pageSize)=>this.getList(page,pageSize)} pageSizeOptions={[5,10,20,50,100]} /> </div>
					</>
				):(
					<div style={{'padding':'2em'}}>
						<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
					</div>
				)}
				
				<Modal
					title="订单信息"
					width={1000}
					visible={this.state.showDialog}
					footer={null}
					onOk={()=>this.submit()}
					onCancel={()=>this.setState({'showDialog':false})}
					>
					<OrderDetail ref={e=>this.orderDetail = e} />
				</Modal>
				
				<Modal
					title="支付订单"
					width={900}
					visible={this.state.showPayDialog}
					footer={null}
					onCancel={()=>this.setState({'showPayDialog':false})}
					>
					<div className="pay-head">
						<dl>
							<dt>
								应付金额：
								<span className="text-red"> ￥{this.state.orderInfo['order_amount']} </span>
							</dt>
							<dd>
								订单编号：{this.state.orderInfo['order_sn']}
							</dd>
							<dd>
								生成时间：{parseTime(this.state.orderInfo['add_time'])}
							</dd>
						</dl>
					</div>
					<div className="height-20"></div>
					<Form
						ref={e=>this.payForm = e}
						onFinish={(data)=>this.submit(data)}
						onFinishFailed={data=>this.focusError(data)}
						labelCol={{ span:3 }}
						wrapperCol={{ span:21 }}>
						<Form.Item name="method" label="充值方式">
							<Form.Item shouldUpdate>
								{()=>(
									<>
										<div className="pay-method">
											<ul>
												{/*
													<li onClick={()=>this.changeMethod('alipay')}>
														<Radio checked={this.payForm && this.payForm.getFieldValue('method') == 'alipay'} value="alipay"></Radio>
														<img className="alipay-icon" src={require("@/assets/images/alipay.png")} />
													</li>
													<li onClick={()=>this.changeMethod('wechatpay')}>
														<Radio checked={this.payForm && this.payForm.getFieldValue('method') == 'wechatpay'} value="wechatpay"></Radio>
														<img className="wechatpay-icon" src={require("@/assets/images/wechatpay.jpg")} />
													</li>
												*/}
												<li onClick={()=>this.changeMethod('allinpay')}>
													<Radio checked={this.payForm && this.payForm.getFieldValue('method') == 'allinpay'} value="allinpay"></Radio>
													<img className="wechatpay-icon" src={require("@/assets/images/allinpay.png")} />
												</li>
												<li onClick={()=>this.changeMethod('moneypay')}>
													<Radio checked={this.payForm && this.payForm.getFieldValue('method') == 'moneypay'} value="moneypay"></Radio>
													<img className="wechatpay-icon" src={require("@/assets/images/money_pay.jpg")} />
												</li>
											</ul>
										</div>
										{this.payForm && this.payForm.getFieldValue('method') == 'wechatpay' && (
											<div className="pay-area">
												<div className="pay-area-left">
													<div className="pay-qr">
														{/*
														<img src={require("@/assets/images/wechat_qr.jpg")} />
														*/}
														<img src={this.state.wechatpay_qrcode} />
													</div>
													<div className="pay-attention">
														<dl>
															<dd className="float-left">
																<img src={require('@/assets/images/wechatpay_focus_ico.jpg')} />
															</dd>
															<dt>
																请使用微信扫一扫
																<br/>
																扫描二维码以完成支付
															</dt>
														</dl>
													</div>
												</div>
												<div className="pay-area-right">
													<img src={require("@/assets/images/wechatpay_exp.jpg")} />
												</div>
											</div>
										)}
										{this.payForm && this.payForm.getFieldValue('method') == 'allinpay' && (
											<div className="pay-area">
												<div className="pay-area-left">
													<div className="pay-qr">
														{/*
														<img src={require("@/assets/images/wechat_qr.jpg")} />
														*/}
														<img src={this.state.wechatpay_qrcode} />
													</div>
													<div className="pay-attention">
														<dl>
															<dd className="float-left">
																<img src={require('@/assets/images/wechatpay_focus_ico.jpg')} />
															</dd>
															<dt>
																请使用微信或支付宝扫一扫
																<br/>
																扫描二维码以完成支付
															</dt>
														</dl>
													</div>
												</div>
												{/*
													<div className="pay-area-right">
														<img src={require("@/assets/images/wechatpay_exp.jpg")} />
													</div>
												*/}
											</div>
										)}
									</>
								)}
							</Form.Item>
						</Form.Item>
						{/*
						<Form.Item shouldUpdate label="营业执照">
							{()=>JSON.stringify(this.payForm && this.payForm.getFieldsValue())}
						</Form.Item>
						*/}
						<Form.Item shouldUpdate wrapperCol={{ offset:3,span:6 }}>
						{()=>this.payForm &&  !['wechatpay','allinpay'].includes(this.payForm.getFieldValue('method')) && (
							<Button block type="primary" htmlType="submit" style={{'width':'18em','height':'36px'}}>确认</Button>
						)}
						</Form.Item>
					</Form>
				</Modal>
			</div>
		);
	}
}



